import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../contexts/AppContext";
import "../../../styles/globals.css";
import "./MedicalInstitutionListPage.css";
import { getMedicalInstituitionList } from "../../../services/service";
import GeneralButton from "../../../components/GeneralButton/GeneralButton";

/**
 * 受診済医療機関画面用のコンポーネント
 * @param {} なし
 * @return {}  なし
 */
function MedicalInstitutionListPage() {
  const navigate = useNavigate();
  const { globalLoginUserInfo, globalAccessToken, globalLoading } =
    useContext(AppContext);
  const [medicalInstitutionList, setMedicalInstitutionList] = useState(null); // 受診済医療機関

  /**
   * コンポーネントがマウントされた時
   */
  useEffect(() => {
    const loadDatas = async () => {
      try {
        const workData = await getMedicalInstituitionList(
          globalAccessToken,
          globalLoginUserInfo.userInfo.adb2cId
        );

        setMedicalInstitutionList(workData?.data?.instituitionList);
      } catch (error) {
        console.error("Error getMedicalInstituitionList:", error);
      }
    };

    if (!globalLoading) {
      loadDatas();
    }
  }, [globalLoading]);

  /**
   * メニューボタンクリック時
   * @param {string} medicalInstitutionId - 選択医療機関
   * @return {}  なし
   */
  const handleMenuClick = (medicalInstitutionId) => {
    // 予約メニュー画面に遷移
    navigate(`/reservation-menu#medicalInstitutionId=${medicalInstitutionId}`);
  };
  /**
   * 戻るボタン押下時の処理
   * @param {} なし
   * @return {} なし
   */
  const handleBackClick = () => {
    navigate("/mypage/menu");
  };
  return (
    <div className="medical-institution-list">
      <div className="main-area">
        <div className="title">受診済医療機関</div>
        <div className="detail">
          過去に受診されたことのある医療機関が表示されます
        </div>
        {medicalInstitutionList && medicalInstitutionList?.length > 0 ? (
          <div className="menu-areas">
            {medicalInstitutionList.map((data) => (
              <div key={data.medicalInstitutionId} className="menu-area">
                <div className="name">{data.medicalInstitutionName}</div>
                <div
                  className="link"
                  onClick={() => handleMenuClick(data.medicalInstitutionId)}
                >
                  予約メニュー選択
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-institution-list">
            <p>受診済医療機関がありません</p>
          </div>
        )}
        <div className="back-to-mypage">
          <GeneralButton
            buttonLabel={"マイページに戻る"}
            type={"secondary-white"}
            onClick={handleBackClick}
          />
        </div>
      </div>
    </div>
  );
}

export default MedicalInstitutionListPage;
